<form #f="ngForm" name="calcForm" [formGroup]="calcForm">
    <div formGroupName="basic">


        <!-- <div class="form-group">
            <label for="exampleInputEmail1">Email address</label>
            <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp">
            <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>
          </div> -->

        <div class="form-group mb-3">
            <label class="mb-2">
                Standard
            </label>
            <ng-container>
                <select class="custom-select rounded-0" formControlName="standard">
                    <option *ngFor="let opt of isoTypeList" [ngValue]="opt.id">
                        {{opt.title}}
                    </option>
                </select>
            </ng-container>
        </div>
    </div>

    <div *ngFor="let questionSegment of arhlCalcIn">
        <div [formGroupName]="questionSegment['id']" *ngFor="let question of questionSegment['questions']" >
            <div class="form-group mb-3" *ngIf="isVisible(question.id)" >
                <label class="mb-1 ">
                    {{question.title}}
                </label>
                <ng-container *ngIf="question.type === 'dropdown'">
                  
                    <select class="custom-select rounded-0" [formControlName]="question.id">
                        <option value=""></option>
                        <option *ngFor="let option of question.options" [value]="option.id">
                            {{option.title}}
                        </option>
                    </select>
                </ng-container>
                <ng-container *ngIf="question.type === 'number'"> 
                    <input type="number" [attr.min]="question?.validation?.min" [attr.max]="question?.validation?.max"
                        class="form-control " [formControlName]="question.id" />
                </ng-container>
                <ng-container *ngIf="question.type === 'switch'"> 

                    <div class="custom-control custom-switch iQswitch">
                        <input class="custom-control-input" type="checkbox" role="switch" [formControlName]="question.id"
                            id="flexSwitchCheckDefault">
                            <label class="custom-control-label" for="flexSwitchCheckDefault">&nbsp;</label>
                    </div>
                </ng-container>
                <div *ngIf="hasError(questionSegment['id'], question.id)">
                     <div class="invalid-error">Input a centile from the 5th to the 95th</div>
                </div>
            </div>
        </div>
    </div>
</form>